import React from 'react';

const Moaz = () => {
  return (
    <div className='why' style={{backgroundColor:"rgb(47,165,226)",width:"100%",height:"60px",display:"flex",flexFlow:"wrap",justifyContent:"space-around",alignItems:"center",color:"white"}}>
         <div  style={{float:"left"}}> <i class="fa fa-copyright" aria-hidden="true">Skyscraper  copy rights reserved      </i>  </div> 
        <div style={{float:"left"}}> 👨🏻‍💻 www.tello.m.m.t.95@gmail.com</div>
    </div>
  )
}

export default Moaz;